import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "keyboard-row" }
const _hoisted_2 = { class: "keyboard-row" }
const _hoisted_3 = { class: "keyboard-row" }
const _hoisted_4 = { class: "keyboard-row" }
const _hoisted_5 = { class: "keyboard-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bootstrap_icon = _resolveComponent("bootstrap-icon")!
  const _directive_katex = _resolveDirective("katex")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('pushCharacter', 'x')))
      }, "x"),
      _createElementVNode("button", {
        class: "number",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('pushCharacter', '1')))
      }, "1"),
      _createElementVNode("button", {
        class: "number",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('pushCharacter', '2')))
      }, "2"),
      _createElementVNode("button", {
        class: "number",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('pushCharacter', '3')))
      }, "3")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('pushCharacter', 'dx')))
      }, "dx"),
      _createElementVNode("button", {
        class: "number",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('pushCharacter', '4')))
      }, "4"),
      _createElementVNode("button", {
        class: "number",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('pushCharacter', '5')))
      }, "5"),
      _createElementVNode("button", {
        class: "number",
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('pushCharacter', '6')))
      }, "6")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('pushCharacter', 'C')))
      }, "C"),
      _createElementVNode("button", {
        class: "number",
        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('pushCharacter', '7')))
      }, "7"),
      _createElementVNode("button", {
        class: "number",
        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('pushCharacter', '8')))
      }, "8"),
      _createElementVNode("button", {
        class: "number",
        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('pushCharacter', '9')))
      }, "9")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('pushCharacter', '+')))
      }, "+"),
      _createElementVNode("button", {
        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('pushCharacter', '-')))
      }, "-"),
      _createElementVNode("button", {
        class: "number",
        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.$emit('pushCharacter', '0')))
      }, "0"),
      _createElementVNode("button", {
        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('pushCharacter', '^')))
      }, [
        _withDirectives((_openBlock(), _createElementBlock("span", null, [
          _createTextVNode("\\( x^n \\)")
        ])), [
          [_directive_katex, void 0, "auto"]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('popCharacter', true)))
      }, [
        _createVNode(_component_bootstrap_icon, { icon: "x-square-fill" })
      ]),
      _createElementVNode("button", {
        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('popCharacter')))
      }, [
        _createVNode(_component_bootstrap_icon, { icon: "backspace-fill" })
      ]),
      _createElementVNode("button", {
        onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('pushCharacter', '=')))
      }, "="),
      _createElementVNode("button", {
        onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.$emit('submit'))),
        class: "green"
      }, [
        _createVNode(_component_bootstrap_icon, { icon: "arrow-return-left" })
      ])
    ])
  ], 64))
}